import type { Person } from "@/FundExplorer/types";
import { z } from "zod";

export type Props = {
	config: string;
	fundId?: number;
	citywireImages?: Record<string, string>;
	managers?: Person[];
};

export const SRPRenderErrorSchema = z.object({
	error: z.string(),
});

export const KeyInfoTablesSchema = z.object({
	data: z
		.tuple([z.string(), z.string().nullable()])
		.or(z.tuple([]))
		.array()
		.optional(),
	error: z.string().optional(),
});
export type KeyInfoTables = z.infer<typeof KeyInfoTablesSchema>;

export const KeyInfoSchema = z.object({
	sectors: KeyInfoTablesSchema,
	tables: KeyInfoTablesSchema.array(),
	yields: KeyInfoTablesSchema,
});

export type KeyInfo = z.infer<typeof KeyInfoSchema>;

export const FundObjectiveSchema = z.object({
	config: z.string(),
	text: z.string(),
});

export const AsAtDateConfigSchema = z.object({
	formattedDate: z.string(),
	formattedDateShort: z.string(),
	date: z.string(),
});

export const FundOverviewSectionSchema = z.object({
	keyinfo: KeyInfoSchema,
	objective: FundObjectiveSchema.or(z.object({})),
	ratings: z.record(z.string()).and(z.object({ note: z.string() })),
	asAtDate: AsAtDateConfigSchema.optional(),
	sdrNote: FundObjectiveSchema.or(z.object({})).optional(),
});

export type FundOverviewSection = z.infer<typeof FundOverviewSectionSchema>;

export const FundObjectiveConfigSchema = z.object({
	title: z.string().optional(),
});
